import {
    REQUEST,
    RESPONSE,
    FAILURE,
    FETCH_TEMPLATES_REQUEST,
    FETCH_TEMPLATES_SUCCESS,
    FETCH_TEMPLATES_FAILURE
} from '../../actions/segments/fields';

const initialState = {
    isLoading: false,
    response: null,
    error: null,
    templates: null,
    templatesLoading: false,
    templatesError: null
};

export default function(state = initialState, action) {
    switch (action.type) {
        case REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null
            };
        case RESPONSE:
            return {
                ...state,
                isLoading: false,
                response: action.payload,
                error: null
            };
        case FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        case FETCH_TEMPLATES_REQUEST:
            return {
                ...state,
                templatesLoading: true,
                templatesError: null
            };
        case FETCH_TEMPLATES_SUCCESS:
            return {
                ...state,
                templatesLoading: false,
                templates: action.payload,
                templatesError: null
            };
        case FETCH_TEMPLATES_FAILURE:
            return {
                ...state,
                templatesLoading: false,
                templatesError: action.payload
            };
        default:
            return state;
    }
} 